import React, { PureComponent } from 'react';
import ReactLoading from 'react-loading';
import PropTypes from 'prop-types';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { Table, TableBody, TableHead, TableCell, TableRow, Switch } from '@mui/material';
import Tile from '../../../../common/components/Tile/Tile';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';

class SystemAlertsConfiguration extends PureComponent {
  render() {
    return (
      <div className="alerts" data-qa="qa-system-alerts-table">
        <Tile
          title="System level alert configuration"
          TitleIcon={SettingsIcon}
          helpTag="system_level_alert_configuration"
        >
          {!this.props.alerts.length ? (
            <p>No data to show</p>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Alert name</TableCell>
                  <TableCell>Settings</TableCell>
                  <TableCell>Computed alert</TableCell>
                  <TableCell>Email notifications</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.alerts.map((el) => (
                  <TableRow key={el.id} hover>
                    <TableCell>{el.name}</TableCell>
                    <TableCell style={{ width: '40%' }}>{el.settings}</TableCell>
                    <TableCell style={{ width: '20%' }}>
                      <PermissionsCheck permission={PermissionsEnum.EDIT_ALERTS}>
                        {el.pending ? (
                          <ReactLoading
                            className="u-ml-half"
                            type="bubbles"
                            color="#34495e"
                            height={'38px'}
                            width={'38px'}
                          />
                        ) : (
                          <Switch
                            data-qa="qa-connectionswitch"
                            checked={el.enabled}
                            onChange={(e) => {
                              this.props.onChange(el.id, e.target.checked, 'Enabled');
                            }}
                          />
                        )}
                      </PermissionsCheck>
                      <PermissionsCheck
                        hasPermission={false}
                        permission={PermissionsEnum.EDIT_ALERTS}
                      >
                        {el.enabled ? 'Yes' : 'No'}
                      </PermissionsCheck>
                    </TableCell>
                    <TableCell style={{ width: '20%' }}>
                      <PermissionsCheck permission={PermissionsEnum.VIEW_ALERTS}>
                        {el.pending ? (
                          <ReactLoading
                            className="u-ml-half"
                            type="bubbles"
                            color="#34495e"
                            height={'38px'}
                            width={'38px'}
                          />
                        ) : (
                          <Switch
                            data-qa="qa-connectionswitch-email"
                            checked={el.emailNotifications}
                            onChange={(e) => {
                              this.props.onChange(el.id, e.target.checked, 'EmailNotifications');
                            }}
                          />
                        )}
                      </PermissionsCheck>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Tile>
      </div>
    );
  }
}

SystemAlertsConfiguration.propTypes = {
  alerts: PropTypes.array,
  onChange: PropTypes.func,
};

export default SystemAlertsConfiguration;
